module.exports = __webpack_public_path__ + "img/SK50595628.af468cb4.png";